var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 73,
    viewBox: "0 0 70 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1410_10294)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.8431,
    cy: 34.8431,
    rx: 34.8431,
    ry: 34.8431,
    fill: "#012269"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1863 34.8431C68.1863 53.258 53.258 68.1863 34.8431 68.1863C16.4282 68.1863 1.5 53.258 1.5 34.8431C1.5 16.4282 16.4282 1.5 34.8431 1.5C53.258 1.5 68.1863 16.4282 68.1863 34.8431Z",
    stroke: "white",
    strokeWidth: 3
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.9634 18.5507L30.9634 18.5507C31.981 17.5012 33.3399 16.9216 34.7875 16.9216H34.8981C36.3523 16.9216 37.7141 17.5038 38.7316 18.5596C38.7317 18.5598 38.7319 18.5599 38.732 18.5601L51.1883 31.4052C53.2902 33.5726 53.2908 37.0909 51.1889 39.2564C50.2642 40.2145 49.0557 40.7807 47.7565 40.8764V47.4645C47.7565 50.3764 45.4627 52.7647 42.6021 52.7647H27.085C24.2243 52.7647 21.9305 50.3764 21.9305 47.4645V40.8763C20.6304 40.7801 19.4212 40.2118 18.4946 39.2538C17.4807 38.2123 16.9219 36.8145 16.9219 35.3335C16.9219 33.8523 17.4813 32.4553 18.5031 31.4029L30.9634 18.5507ZM30.9634 18.5507L18.5034 31.4026L30.9634 18.5507ZM37.2519 46.3779C37.2519 47.5483 36.2117 48.5648 34.8419 48.5648C33.4733 48.5648 32.4333 47.5488 32.4333 46.3779V43.1777C32.4333 42.007 33.473 40.9908 34.8419 40.9908C36.2114 40.9908 37.2519 42.007 37.2519 43.1777V46.3779Z",
    fill: "white",
    stroke: "#012269"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1410_10294",
    x: 0,
    y: 0,
    width: 69.6875,
    height: 72.6863,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.00392157 0 0 0 0 0.133333 0 0 0 0 0.411765 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1410_10294"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1410_10294",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.aed39c503ee04a7e3d533c5d089b5338.svg";
export { ForwardRef as ReactComponent };